import { createApp } from 'vue';
import PdfToJpgConverter from '@/Components/PdfToJpgConverter.vue';
import '@styles/app.css';

createApp(PdfToJpgConverter).mount('#pdf-to-jpg-converter');
